import featureFlags from 'modules/FeatureFlags';

export const SHOW_LANGUAGE_SELECTOR_FF = 'showLanguageSelector';

export function useFeatureFlagLanguageSelector(): boolean {
  return Boolean(featureFlags.getFlag(SHOW_LANGUAGE_SELECTOR_FF));
}
